import {config} from 'src/app/constants/config/config';

let prefetched = false;

/**
 * Warms the browser cache with the Admin app's boot assets after React login, so the first embedded
 * render hits a hot cache. Uses a hidden, offscreen
 * warm iframe pointed at an `/embed/*` route: it boots the WASM runtime and downloads every
 * fingerprinted asset without triggering a login (embed mode never redirects) — the most reliable
 * warm-up given content-fingerprinted asset names. Runs at most once per session.
 */
export const prefetchAdminAssets = () => {
    if (prefetched || !config.ADMIN_UI_URL) {
        return;
    }
    prefetched = true;

    let adminOrigin: string;
    try {
        adminOrigin = new URL(config.ADMIN_UI_URL).origin;
    } catch {
        return;
    }

    // A lightweight DNS/preconnect hint plus the entry document.
    const preconnect = document.createElement('link');
    preconnect.rel = 'preconnect';
    preconnect.href = adminOrigin;
    document.head.appendChild(preconnect);

    const warm = document.createElement('iframe');
    warm.setAttribute('aria-hidden', 'true');
    warm.tabIndex = -1;
    warm.style.position = 'absolute';
    warm.style.width = '1px';
    warm.style.height = '1px';
    warm.style.opacity = '0';
    warm.style.border = 'none';
    warm.style.left = '-9999px';
    // Use the origin (no trailing slash) so a configured "http://host:5095/" does not become "//embed".
    warm.src = `${adminOrigin}/embed/contracts`;
    document.body.appendChild(warm);
};
